import React from "react";
import { ReportContext } from "../../layout/Content/MainContent.component";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import { get_mediums, get_metrics, get_contenttype_mediums, submit_report, export_simulation_report } from "../../config/apiUrls";
import SingleSelect from "../common/dropdown/SingleSelect.component";
import ClipLoader from "react-spinners/ClipLoader";
import Dropdown from "../common/dropdown/Dropdown.component";
import DialogBox from "../common/Dialog/Dialog.component";
import SimulationResultTable from "./simulationResultTable"
import { makeStyles, withStyles, } from "@material-ui/core/styles";

const useStyles = makeStyles({
  table: {
    // minWidth: 700,
    // width: "2048px"
    width: "auto"
  },
  name: {
    fontFamily: "OpenSans",
    fontWeight: 600
  },
  divider: {
    borderLeft: "1px solid",
    margin: "3px 7px",
    height: 15
  },
  text: {
    fontFamily: "OpenSans",
    fontSize: "0.75rem",
    color: "#999",
    alignItems: "center"
  },
  textBold: {
    marginLeft: 3,
    fontWeight: 600
  },
  button: {
    margin: 5,
    '&.Mui-disabled': {
      backgroundColor: "rgba(25,118,210, 0.7)",
      color: "#fff"
    },
  },
  buttonLabel: {
    fontFamily: "OpenSans",
    fontWeight: 400,
    fontSize: "0.92rem"
  },
  button1: {
    // marginLeft: "auto",
    height: 37,
    margin: 5,
    backgroundColor: "#4caf50",
    "&:hover": {
      backgroundColor: "#388e3c"
    }
  },
  root: {
    display: "flex",
    justifyContent: "space-between",
    width: "70%",
    marginTop: "2rem",
    margin: "auto"
  },
  label: {
    fontSize: "0.85rem",
    fontFamily: "OpenSans",
    fontWeight: "bold",
    marginBottom: 8
  }
});
const BodyTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    border: "1px solid #dde6ed",
    fontFamily: "OpenSansBold",
    fontSize: "0.8rem !important",
    whiteSpace: "nowrap"
  },
  body: {
    fontSize: 14,
    border: "1px solid #dde6ed",
    whiteSpace: "nowrap"
    //minWidth: "160px"
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f9fc"
    }
  }
}))(TableRow);

function SimulateReport(props) {
  const classes = useStyles();

  const {
    activeTab,
    handlePrev,
    networks,
    contentTypes: allContentTypes,
    year,
    week,
    period,
    spec,
    setSpec,
    navigateToCreateNewReport,
    selectedMediums,
    setSelectedMediums,
    simulateData,
    setSimulateData,
    selectedMetrics,
    setSelectedMetrics,
    userInfo
  } = React.useContext(ReportContext);

  const [metrics, setMetrics] = React.useState([]);
  const [mediums, setMediums] = React.useState([]);
  const [contentTypeMedium, setContentTypeMedium] = React.useState([]);
  const [validList, setValidList] = React.useState([]);
  // const [selectedMediums, setSelectedMediums] = React.useState([]);

  const [metricSelection, setMetricSelection] = React.useState(selectedMetrics);
  const [reportData, setReportData] = React.useState(simulateData);

  // const [allContentTypes, setAllContentTypes] = React.useState([]);

  const [simulateReportLoading, setSimulateReportLoading] = React.useState(true);
  const [simulateResultLoading, setSimulateResultLoading] = React.useState(false);
  const [showSimulateResult, setShowSimulateResult] = React.useState(false);
  const [simulateResult, setSimulateResult] = React.useState(false);
  const [resultFilter, setResultFilter] = React.useState({ data: "uplift", label: "Uplift" });

  React.useEffect(() => {
    setSimulateData(reportData)
  }, [reportData])

  React.useEffect(() => {
    if (selectedMediums.length > 0) {
      let tempMetric = { ...metricSelection }
      selectedMediums.forEach(el => {
        if (tempMetric[el.medium] === undefined) {
          tempMetric[el.medium] = metrics.filter(metric => metric.metricId == el.metricId)[0]
        }
      })
      setMetricSelection(tempMetric)
    }

  }, [selectedMediums])

  React.useEffect(() => {
    setSelectedMetrics(metricSelection)
  }, [metricSelection])

  function createReportData() {
    let rData = [];

    let defaultMetricValues = {};

    allContentTypes.map((row, index) => {
      let record = {};
      let contentTypeJson = {};
      contentTypeJson["contentType"] = row.contentType;
      contentTypeJson["contentTypeDisplayName"] = row.contentTypeDisplayName;
      record["content_type"] = contentTypeJson;
      let temp = reportData.filter(el => el.content_type["contentType"] === row.contentType)
      temp = temp ? temp[0] : []
      selectedMediums.map(medium => {
        metrics.map(row => {
          defaultMetricValues[row.metric] = temp && temp[medium.medium] ? temp[medium.medium][row.metric] : 0;
        });
        record[medium.medium] = { ...defaultMetricValues };
      });
      rData.push(record);
    });
    setReportData(rData);
  }

  function setUpData() {
    var selectedMetric = {};
    var metricArray = [];
    for (var item in metrics) {
      metricArray.push(metrics[item]["metric"]);
    }
    for (var item in selectedMediums) {
      selectedMetric[selectedMediums[item]["medium"]] = metricSelection[selectedMediums[item]["medium"]] ? metricSelection[selectedMediums[item]["medium"]] : metricArray[0];
    }
    // setMetricSelection(selectedMetric);
  }

  function getContentTypeId(contentType) {
    return allContentTypes.filter(el => el.contentType === contentType)[0].contentTypeId
  }

  function getData() {
    const getMediums = axios.get(get_mediums);
    const getMetrices = axios.get(get_metrics);
    const getContentTypeMedium = axios.get(get_contenttype_mediums);
    // const getContentTypes = axios.get(get_content_types);

    axios
      .all([getMediums, getMetrices, getContentTypeMedium])
      .then(
        axios.spread((...responses) => {
          setMediums(responses[0].data);
          setMetrics(responses[1].data);
          setContentTypeMedium(responses[2].data)
          // setAllContentTypes(responses[2].data);
          setSimulateReportLoading(false);
        })
      )
      .catch(errors => {
        // react on errors.
      });
  }
  React.useEffect(() => {
    getData();
  }, []);

  React.useEffect(() => {
    if (
      selectedMediums.length > 0 &&
      metrics.length > 0 &&
      allContentTypes.length > 0
    ) {
      // setReportData([]);
      setUpData();
      createReportData();
    }
  }, [selectedMediums]);

  React.useEffect(() => {
    let validContentTypes = {}
    contentTypeMedium.map(el => {
      let temp = {}
      el.contentTypeIds.forEach(el => {
        temp["contentType_" + el.contentTypeId] = el.enable === 0 ? false : true
      })
      validContentTypes["medium_" + el.mediumId] = temp
    })
    setValidList(validContentTypes)
  }, [contentTypeMedium])

  function creatSimulateSpec() {
    let simulateSpec = [];
    let specElement = {};
    selectedMediums.map(medium => {
      specElement = {};
      specElement['medium'] = medium.medium;
      specElement['metric'] = metricSelection[medium.medium].metric;
      let contentJson = {};
      reportData.filter(data => {
        return validList["medium_" + medium.mediumId]["contentType_" + getContentTypeId(data.content_type.contentType)]
      }).map(row => {
        contentJson[row.content_type.contentType] =
          row[medium.medium][metricSelection[medium.medium].metric];
      });
      specElement['contentTypes'] = contentJson;
      simulateSpec.push(specElement);
    });
    let currentSpec = { ...spec }
    currentSpec["mediums"] = simulateSpec
    setSpec(currentSpec);
    handleSubmit(currentSpec);
  }
  function updateCell(index, column, e) {
    let row = { ...reportData[index] };
    if (!isNaN(parseInt(e.target.value))) {
      row[column][metricSelection[column].metric] = parseInt(e.target.value);

      let updatedReportData = [...reportData];
      updatedReportData[index] = { ...row };
      setReportData(updatedReportData);
    }
  }
  /* const renderMetricFilter = () => {
    return (
      <TableRow>
        <BodyTableCell>Metric</BodyTableCell>
        {mediums.map((row, index) => (
          <BodyTableCell align="center">
            <select
              name={row.medium}
              id={row.medium}
              onChange={event => handleChangeInMetricSelection(event)}
            >
              {metrics.map(metric => (
                <option value={metric.metric}>
                  {metric.metricDisplayName}
                </option>
              ))}
            </select>
          </BodyTableCell>
        ))}
      </TableRow>
    );
  }; */
  const renderHeader = () => {
    return (
      <TableRow>
        <BodyTableCell
          align="left"
          style={{ position: "sticky", left: 0, zIndex: 3 }}
        >
          <div style={{ height: 40 }}>Metric</div> <Divider /> Content Type
        </BodyTableCell>
        {selectedMediums.map((row, index) => (
          <BodyTableCell align="center" key={index}>
            <div style={{ marginBottom: 5 }}>{metricSelection[row.medium] && <SingleSelect
              name={row.medium}
              id={row.medium}
              items={metrics}
              idKey={"metricId"}
              defaultValue={metricSelection[row.medium] ?.metricId}
              onChange={value =>
                handleChangeInMetricSelection(value, row.medium)
              }
              labelKey={"metricDisplayName"}
            ></SingleSelect>}
            </div>
            {/* <select
              name={row.medium}
              id={row.medium}
              onChange={event => handleChangeInMetricSelection(event)}
            >
              {metrics.map(metric => (
                <option value={metric.metric}>
                  {metric.metricDisplayName}
                </option>
              ))}
            </select> */}
            <Divider />
            {row.mediumDisplayName}
          </BodyTableCell>
        ))}
      </TableRow>
    );
  };

  const RenderTableHeader = () => {
    const networkDisplayNames = networks
      .map(el => el.networkDisplayName)
      .toString();
    return (
      <div
        style={{
          display: "flex",
          height: 32,
          alignItems: "flex-end",
          padding: "5px 20px", //"1px 20px",
          //padding: "0px 110px 0px 30px" //"5px 20px"
          width: "calc(70% - 40px)",
          marginLeft: "15%",
          marginRight: "15%",
          marginTop: 30,
          boxShadow:
            "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)"
        }}
      >
        <div className={classes.name}>Simulation Report</div>
        <div
          className={classes.text}
          style={{ display: "flex", marginLeft: "auto" }}
        >
          <div>
            Network :
            <span className={classes.textBold}>{networkDisplayNames}</span>
          </div>
          <div className={classes.divider} />
          <div>
            Year :<span className={classes.textBold}>{year ?.year}</span>
          </div>
          <div className={classes.divider} />
          <div>
            Week {week ?.weekId}:
            <span className={classes.textBold}>{period}</span>
          </div>
        </div>
      </div>
    );
  };

  function handleChangeInMetricSelection(value, colName) {
    let updatedSelection = { ...metricSelection };
    updatedSelection[colName] = value;
    setMetricSelection(updatedSelection);
  }

  function renderTableData() {
    return reportData.map((record, index) => (
      <StyledTableRow key={index}>
        <BodyTableCell
          // component="th"
          scope="row"
          style={{ position: "sticky", left: 0, zIndex: 2, backgroundColor: "inherit" }}
        >
          {record.content_type.contentTypeDisplayName}
        </BodyTableCell>
        {selectedMediums.map((medium, index2) => (
          <BodyTableCell align="center" key={index + "_" + index2}>
            <input
              type="number"
              id={index2}
              col={medium}
              value={record[medium["medium"]] ? record[medium["medium"]][metricSelection[medium.medium].metric] : 0}
              onChange={event => updateCell(index, medium.medium, event)}
              disabled={!validList["medium_" + medium.mediumId]["contentType_" + getContentTypeId(record.content_type.contentType)]}
            />
            {}
          </BodyTableCell>
        ))
        }
      </StyledTableRow >
    ));
  }
  const handleSubmit = sumulateSpec => {
    let payload = {
      year: sumulateSpec.year,
      // dates:spec.dates,            
      reportType: sumulateSpec.reportType,
      reportName: sumulateSpec.reportName,
      weekId: sumulateSpec.weekId,
      userId: userInfo.email,
      statusId: 1,
      networkDisplayName: sumulateSpec.networkDisplayName,
      input: JSON.stringify(sumulateSpec)
    }
    setSimulateResultLoading(true);
    setShowSimulateResult(true);
    axios.post(submit_report, payload).then(responses => {
      setSimulateResultLoading(false);
      setSimulateResult(responses.data);
      // let array = [176, 2760]
      // let report = array[Math.floor(Math.random() * array.length)];
      // axios.post("api/fetch_simulation_report/", { reportId: report }).then(res => {
      //   setSimulateResultLoading(false);
      //   setSimulateResult(res.data);
      // })
    })
  }

  return (
    <React.Fragment>

      <div className={classes.root}>
        <div>
          <div className={classes.label}>Channel/Medium</div>
          <Dropdown items={mediums} defaultSelect={false} placeholder={"Select Channel/Medium"} defaultValue={selectedMediums} onChange={data => { setSelectedMediums(data) }} labelKey={"mediumDisplayName"} />
        </div>
        <div style={{ margin: "5px 10px", marginLeft: "auto", fontSize: "0.85rem" }}>
          - Spend represents $(000s)<br />
          - Impressions represents (000s)
        </div>
        <Button
          variant="contained" color="primary"
          classes={{ root: classes.button1, label: classes.buttonLabel }}
          onClick={navigateToCreateNewReport}
        >
          CREATE NEW REPORT
          </Button>
      </div>
      <RenderTableHeader />
      <TableContainer
        component={Paper}
        style={{ maxHeight: "calc(100vh - 340px)", borderRadius: 0, minHeight: 80 }}
      >
        {!simulateReportLoading && <Table stickyHeader className={classes.table} aria-label="simple table">
          <TableHead>{renderHeader()}</TableHead>
          {<TableBody>{renderTableData()}</TableBody>}
        </Table>}
        <center>
          <ClipLoader
            color={"#1976d2"}
            align="center"
            loading={simulateReportLoading}
            size={60}
          />
        </center>
      </TableContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "0px 20px",
          width: "70%",
          margin: "auto"
        }}
      >
        <Button
          variant="outlined"
          classes={{ root: classes.button, label: classes.buttonLabel }}
          onClick={e => handlePrev(activeTab)}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          classes={{ root: classes.button, label: classes.buttonLabel }}
          onClick={e => {
            creatSimulateSpec();
          }}
          disabled={selectedMediums.length === 0}
        >
          SIMULATE
        </Button>
      </div>
      {showSimulateResult &&
        <DialogBox open={showSimulateResult} fullWidth={false} maxWidth={"xl"} onClose={() => { setShowSimulateResult(false); setResultFilter({ data: "uplift", label: "Uplift" }); setSimulateResult(null); }} title={"Simulation Report"}>
          {
            simulateResultLoading &&
            <div style={{ minHeight: 80 }}>
              <center>
                <ClipLoader
                  color={"#1976d2"}
                  align="center"
                  loading={simulateResultLoading}
                  size={60}
                />
                <div>Loading Result...</div>
              </center>
            </div>
          }
          {!simulateResultLoading && simulateResult && simulateResult.networks.length > 0 &&
            <div>
              <div style={{ position: "absolute", marginLeft: 150, marginTop: 15 }}>
                {/* <div style={{ fontSize: "0.7rem", fontWeight: 600, fontFamily: "OpenSans", marginBottom: 5 }}>Viewing Minutes/Uplift</div> */}
                <SingleSelect
                  name={"resultFilter"}
                  items={[{ data: "viewingMinutes", label: "Viewing Minutes" }, { data: "uplift", label: "Uplift" },]}
                  defaultValue={resultFilter}
                  onChange={setResultFilter}
                  styles={{ maxWidth: 150 }}
                  labelKey={"label"}
                /></div>
              {simulateResult.networks.map((network, index) => (
                <React.Fragment key={index}>
                  <SimulationResultTable index={index} filter={resultFilter ?.data} data={network} headers={simulateResult.mediums} reportId={simulateResult.reportId} />
                </React.Fragment>
              ))}
            </div>
          }
          {!simulateResultLoading && simulateResult && simulateResult.networks.length === 0 &&
            <div style={{ padding: 10 }}>No data found</div>
          }
        </DialogBox>}
    </React.Fragment >
  );
}

export default SimulateReport;
